import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div style={{ padding: '2rem', maxWidth: '800px', margin: '0 auto', fontFamily: 'sans-serif', color: '#333' }}>
      <h1>Política de Privacidad</h1>
      <p>Última actualización: {new Date().toLocaleDateString()}</p>
      
      <section>
        <h2>1. Introducción</h2>
        <p>En Portal Oracle, nos tomamos muy en serio la privacidad de tus datos. Esta Política de Privacidad explica cómo recopilamos, usamos y protegemos la información personal que nos proporcionas al utilizar nuestra plataforma.</p>
      </section>

      <section>
        <h2>2. Información que recopilamos</h2>
        <ul>
          <li><strong>Datos de cuenta:</strong> Al registrarte, recopilamos tu nombre y dirección de correo electrónico.</li>
          <li><strong>Datos de uso:</strong> Recopilamos información sobre cómo interactúas con nuestras herramientas (ej. lecturas de oráculo, progreso en cursos, herramientas de meditación).</li>
          <li><strong>Datos de pago:</strong> Procesamos información relacionada con tus compras y suscripciones de forma segura a través de terceros.</li>
        </ul>
      </section>

      <section>
        <h2>3. Cómo usamos tus datos</h2>
        <p>Utilizamos la información recopilada para:</p>
        <ul>
          <li>Gestionar tu cuenta y acceso a los cursos.</li>
          <li>Personalizar tu experiencia en la plataforma (dashboard, historial de actividades).</li>
          <li>Enviarte comunicaciones importantes o newsletters si te has suscrito.</li>
          <li>Procesar tus pagos y gestionar tus suscripciones.</li>
        </ul>
      </section>

      <section>
        <h2>4. Seguridad y Terceros</h2>
        <p>No vendemos tus datos personales. Utilizamos servicios de terceros de confianza (como proveedores de autenticación y pasarelas de pago) para garantizar la seguridad de tus transacciones y datos. Toda la comunicación se realiza bajo protocolos cifrados (HTTPS).</p>
      </section>

      <section>
        <h2>5. Tus derechos</h2>
        <p>Puedes acceder, modificar o solicitar la eliminación de tus datos en cualquier momento. Si deseas eliminar tu cuenta o darte de baja de nuestras comunicaciones, puedes hacerlo a través de la sección de perfil en tu cuenta o enviándonos un correo a gustavonahuelaguiar@gmail.com.</p>
      </section>

      <section>
        <h2>6. Cambios en esta política</h2>
        <p>Podemos actualizar esta política ocasionalmente. Te notificaremos sobre cualquier cambio importante a través de la plataforma o vía correo electrónico.</p>
      </section>
    </div>
  );
};

export default PrivacyPolicy;